import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-accent-500">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                爱丫爱丫影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              电视剧大全全集免费在线观看，最新国产剧、韩剧全集高清不缓冲，流畅播放，秒开看剧。每日更新，免费高清影视尽在爱丫爱丫影院。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">
              关于平台
            </h3>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">
              内容导航
            </h3>
            <ul className="space-y-2">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">
              特色功能
            </h3>
            <ul className="space-y-2">
              {footerLinks.features.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="mb-4">
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-2">
              合作伙伴
            </h3>
            <p className="text-sm text-background-500">
              诚邀优质内容方与平台合作，共同打造更好的观影体验
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 爱丫爱丫影院. 电视剧大全全集免费在线观看.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#hero');
                }}
                className="text-xs text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                回到顶部
              </a>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#faq');
                }}
                className="text-xs text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                帮助中心
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}